var map = {
	"./A_rare_silk_nearly_lost_through_war.jpg": 2538,
	"./A_rare_silk_nearly_lost_through_war_Hero_thumb.jpg": 7355,
	"./AtightlyguardedHimalayansecret.jpg": 6001,
	"./AtightlyguardedHimalayansecretDesktop.jpg": 9117,
	"./Canadas_rising_Inuit_TikTok_star.jpg": 5815,
	"./Mask.png": 7581,
	"./New_Zealands_feisty_feathered_patient.jpg": 8310,
	"./The_extreme_life_of_Europes_sherpas.jpg": 2370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2786;